/* Dock product page (workstream pdp, rebuild 2026-10). No dependencies.
   Picks are keyed by variant ID (allowed list rendered by Liquid from the SKUs); titles are never read.
   Public hook: window.ascPdp (see .build/contracts/pdp.md). Remembered Mac: localStorage 'asc.mac' = variant ID. */
(function () {
  'use strict';
  var MEM_KEY = 'asc.mac';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function memGet() { try { return localStorage.getItem(MEM_KEY); } catch (e) { return null; } }
  function memSet(id) { try { localStorage.setItem(MEM_KEY, String(id)); } catch (e) {} }

  /* ---------- cart: the cart workstream's API, with the plain AJAX fallback ---------- */
  function addToCart(items) {
    if (window.ascCart && typeof window.ascCart.add === 'function') {
      return window.ascCart.add(items, { open: true, source: 'pdp' });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
        document.dispatchEvent(new CustomEvent('asc:cart:refresh'));
        document.dispatchEvent(new CustomEvent('asc:cart:open'));
        return j;
      });
    });
  }

  /* ---------- dialogs: native <dialog>, focus kept inside, focus returned to the opener ---------- */
  var openers = new WeakMap();
  function openDialog(dlg, opener) {
    if (!dlg) return;
    if (dlg.open) return;
    openers.set(dlg, opener || document.activeElement);
    // fr1 #17: the page behind keeps its scroll position while a dialog opens and after it closes
    var y = window.scrollY;
    dlg._ascY = y;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('asc-dlg-open');
    var first = dlg.querySelector('[data-asc-autofocus]') || dlg.querySelector('.asc-dlg__x');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    keepY(y);
  }
  function keepY(y) {
    var fix = function () {
      if (Math.abs(window.scrollY - y) > 1) {
        var h = document.documentElement, prev = h.style.scrollBehavior;
        h.style.scrollBehavior = 'auto'; window.scrollTo(0, y); h.style.scrollBehavior = prev;
      }
    };
    fix(); requestAnimationFrame(fix); setTimeout(fix, 60); setTimeout(fix, 200);
  }
  function closeDialog(dlg) {
    if (!dlg || !dlg.open) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }
  function onDialogClosed(dlg) {
    if (!$$('dialog.asc-dlg[open]').length) document.documentElement.classList.remove('asc-dlg-open');
    if (typeof dlg._ascY === 'number' && !dlg._ascNoRestore) keepY(dlg._ascY);
    dlg._ascNoRestore = false;
    var back = openers.get(dlg);
    if (back && document.contains(back) && typeof back.focus === 'function') {
      try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
    }
  }
  function trapFocus(e) {
    if (e.key !== 'Tab' && e.key !== 'Escape' && e.key !== 'Esc') return;
    var dlgs = $$('dialog.asc-dlg[open]');
    if (!dlgs.length) return;
    var dlg = dlgs[dlgs.length - 1];
    if (e.key !== 'Tab') { e.preventDefault(); e.stopPropagation(); closeDialog(dlg); return; }
    var f = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', dlg)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dlg.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !dlg.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }

  /* ---------- delivery line, from the c-edd app's own settings (D15) ---------- */
  function eddText() {
    var s = window.deliveryED && window.deliveryED.setting && window.deliveryED.setting.delivery__app_setting;
    s = s && s.main_delivery_setting;
    if (!s || !s.is_active) return null;
    var tz = Number(s.timezone);
    if (!isFinite(tz)) tz = 0;
    var now = new Date(Date.now() + tz * 3600e3); // shop-local clock in UTC fields
    var readyWeek = s.order_ready_work_week || [1, 1, 1, 1, 1, 1, 1];
    var delWeek = s.order_delivery_work_week || [0, 1, 1, 1, 1, 1, 0];
    var readyRange = s.order_ready_day_range || [0, 1];
    var delRange = s.order_delivery_day_range || [2, 5];
    var holidays = (s.holiday || []).filter(function (h) { return typeof h === 'string'; });
    function ymd(d) { return d.toISOString().slice(0, 10); }
    function isWork(d, week) { return !!week[d.getUTCDay()] && holidays.indexOf(ymd(d)) === -1; }
    function day(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
    function cutoffOf(d) {
      var h = Number(s.countdown_cutoff_hour), m = Number(s.countdown_cutoff_minute);
      if (s.countdown_cutoff_advanced_enable && s.countdown_cutoff_advanced && s.countdown_cutoff_advanced[d.getUTCDay()]) {
        h = Number(s.countdown_cutoff_advanced[d.getUTCDay()][0]); m = Number(s.countdown_cutoff_advanced[d.getUTCDay()][1]);
      }
      var c = new Date(d.getTime()); c.setUTCHours(isFinite(h) ? h : 23, isFinite(m) ? m : 59, 0, 0); return c;
    }
    function addWork(d, n, week) {
      var x = new Date(d.getTime()), guard = 0;
      while (!isWork(x, week) && guard++ < 30) x = day(x, 1);
      while (n > 0 && guard++ < 60) { x = day(x, 1); if (isWork(x, week)) n--; }
      return x;
    }
    var orderDay = new Date(now.getTime()), guard = 0;
    while ((!isWork(orderDay, readyWeek) || now >= cutoffOf(orderDay)) && guard++ < 14) {
      orderDay = day(orderDay, 1); orderDay.setUTCHours(0, 0, 0, 0);
    }
    var cutoff = cutoffOf(orderDay);
    var mins = Math.max(1, Math.round((cutoff - now) / 60000));
    var readyMin = addWork(orderDay, Number(readyRange[0]) || 0, readyWeek);
    var readyMax = addWork(orderDay, Number(readyRange[1]) || 0, readyWeek);
    var dMin = addWork(readyMin, Number(delRange[0]) || 0, delWeek);
    var dMax = addWork(readyMax, Number(delRange[1]) || 0, delWeek);
    var h = Math.floor(mins / 60), m = mins % 60;
    var left = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
    var a = MONTHS[dMin.getUTCMonth()] + ' ' + dMin.getUTCDate();
    var b = dMin.getUTCMonth() === dMax.getUTCMonth() ? String(dMax.getUTCDate()) : MONTHS[dMax.getUTCMonth()] + ' ' + dMax.getUTCDate();
    var when = ymd(dMin) === ymd(dMax) ? a : a + ' to ' + b;
    return 'Order in <b>' + left + '</b>, <span class="asc-nw">get it <b>' + when + '</b> (estimate)</span>';
  }

  function initPdp(root) {
    var sid = root.getAttribute('data-section');
    var dataEl = $('script[data-asc-pdp-data="' + sid + '"]');
    var data = { macs: [] };
    try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    var macs = {};
    data.macs.forEach(function (m) { macs[String(m.id)] = m; });
    var allowed = function (id) { return Object.prototype.hasOwnProperty.call(macs, String(id)); };
    var picked = root.getAttribute('data-picked') || '';
    var form = $('[data-asc-form]', root);
    var idInput = $('[data-asc-id]', root);
    var qtyInput = $('.asc-qty__input', $('[data-asc-qty]', root));
    var atc = $('[data-asc-atc]', root);
    var errEl = $('[data-asc-error]', root);
    var nudge = $('[data-asc-nudge]', root);
    var stickyDesk = $('[data-asc-sticky-desk]');
    var stickyMob = $('[data-asc-sticky-mob]');
    var dlg = {};
    $$('dialog[data-asc-dlg]').forEach(function (d) {
      dlg[d.getAttribute('data-asc-dlg')] = d;
      d.addEventListener('close', function () { onDialogClosed(d); });
      d.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(d); });
      d.addEventListener('click', function (e) { if (e.target === d) closeDialog(d); }); // backdrop
    });
    var sheetMode = 'pick';
    var sheetChoice = '';

    /* ----- gallery ----- */
    var gal = $('[data-asc-gal]', root);
    var track = $('[data-asc-gal-track]', gal);
    var countEl = $('[data-asc-gal-count]', gal);
    var slides = $$('.asc-gal__slide', track);
    var thumbs = $$('[data-asc-gal-thumbs] > li', gal);
    function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }
    function currentIndex() {
      var vis = visibleSlides();
      if (!vis.length) return 0;
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(vis.length - 1, Math.round(track.scrollLeft / w)));
    }
    function updateCount() {
      var vis = visibleSlides(), i = currentIndex();
      countEl.textContent = (i + 1) + '/' + vis.length;
      var visThumbs = thumbs.filter(function (t) { return !t.hidden; });
      visThumbs.forEach(function (t, k) {
        var b = t.querySelector('button');
        b.classList.toggle('is-on', k === i);
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
        b.setAttribute('aria-label', 'Show image ' + (k + 1) + ' of ' + visThumbs.length);
      });
      galActive = i;
      syncVideos();
    }
    // gallery video: plays only while its slide is the active one AND the gallery is at least half on screen
    var galActive = 0, galInView = false;
    // pick the smallest 480–720p MP4 from the product JSON (Liquid only offers 1080p); fall back to the 1080p URL
    var productJson = null;
    function withSource(v, cb) {
      if (v.getAttribute('src') || v.querySelector('source')) { cb(); return; }
      if (v._ascLoading) return; v._ascLoading = true;
      var set = function (url) { if (url) { v.src = url; } v._ascLoading = false; cb(); };
      (productJson || (productJson = fetch(root.getAttribute('data-product-url') + '.js').then(function (r) { return r.json(); })))
        .then(function (p) {
          var id = Number(v.getAttribute('data-media-id')), best = null;
          var need = (track.clientWidth || 600) * (window.devicePixelRatio || 1); // device pixels the slide shows
          var ok = [];
          (p.media || []).forEach(function (m) {
            if (m.id !== id) return;
            (m.sources || []).forEach(function (s) { if (s.format === 'mp4' && s.height >= 480 && s.height <= 720) ok.push(s); });
          });
          ok.sort(function (a, b) { return a.height - b.height; });
          ok.forEach(function (s) { if (!best && s.width >= need * 0.9) best = s; });
          if (!best && ok.length) best = ok[ok.length - 1];
          set(best ? best.url : v.getAttribute('data-fallback'));
        })
        .catch(function () { set(v.getAttribute('data-fallback')); });
    }
    /* fr3 #7: the shopper's controls. Leaving the card (swipe) pauses it, mutes it again and forgets a manual pause; the
       gallery scrolling off screen only pauses (sound choice kept). Never fullscreen (playsinline, no requestFullscreen). */
    function playV(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { if (!v.muted) { v.muted = true; vcSync(v); var q = v.play(); if (q && q.catch) q.catch(function () {}); } });
    }
    function vcSync(v) {
      var c = v._ascVc; if (!c) return;
      c.root.classList.toggle('is-paused', v.paused);
      c.root.classList.toggle('is-sound', !v.muted);
      c.play.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
      c.mute.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
      c.mute.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      if (!c.dragging && v.duration) c.seek.value = Math.round(v.currentTime / v.duration * 1000);
      c.seek.style.setProperty('--p', (c.seek.value / 10) + '%');
    }
    function vcWire(v) {
      if (v._ascVc) return;
      var root = v.parentNode.querySelector('[data-asc-vc]'); if (!root) return;
      var c = v._ascVc = { root: root, play: root.querySelector('[data-asc-vc-play]'), mute: root.querySelector('[data-asc-vc-mute]'), seek: root.querySelector('[data-asc-vc-seek]'), dragging: false };
      function toggle() { withSource(v, function () { if (v.paused) { v._ascUserPaused = false; playV(v); } else { v._ascUserPaused = true; v.pause(); } vcSync(v); }); }
      v.addEventListener('click', toggle);
      c.play.addEventListener('click', toggle);
      c.mute.addEventListener('click', function () { v.muted = !v.muted; if (!v.muted && v.paused && !v._ascUserPaused) playV(v); vcSync(v); });
      c.seek.addEventListener('input', function () { c.dragging = true; withSource(v, function () { if (v.duration) v.currentTime = c.seek.value / 1000 * v.duration; c.seek.style.setProperty('--p', (c.seek.value / 10) + '%'); }); });
      c.seek.addEventListener('change', function () { c.dragging = false; });
      ['play', 'pause', 'volumechange', 'timeupdate', 'loadedmetadata'].forEach(function (ev) { v.addEventListener(ev, function () { vcSync(v); }); });
      vcSync(v);
    }
    function syncVideos() {
      visibleSlides().forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        vcWire(v);
        if (k === galActive) {
          if (galInView && !v._ascUserPaused) withSource(v, function () { if (k === galActive && galInView && !v._ascUserPaused) playV(v); });
          else if (!galInView && !v.paused) v.pause();
          v._ascWasActive = true;
        } else {
          if (!v.paused) v.pause();
          if (v._ascWasActive) { v.muted = true; v._ascUserPaused = false; v._ascWasActive = false; vcSync(v); } // swiped away
        }
      });
      gal.classList.toggle('is-video', !!(visibleSlides()[galActive] && visibleSlides()[galActive].querySelector('video')));
    }
    if (track && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { galInView = es[0].isIntersecting; syncVideos(); }, { threshold: 0.5 }).observe(track);
    }
    function goTo(i, smooth) {
      var vis = visibleSlides();
      if (!vis.length) return;
      i = (i + vis.length) % vis.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      if (smooth === false) updateCount();
    }
    function filterGallery(id) {
      var tag = id ? ' ' + id + ' ' : ' main_image ';
      var any = slides.some(function (s) { return s.getAttribute('data-tags').indexOf(tag) > -1; });
      if (!any) tag = ' main_image ';
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-tags').indexOf(tag) === -1; });
      thumbs.forEach(function (t) { t.hidden = t.getAttribute('data-tags').indexOf(tag) === -1; });
      $$('img[loading="lazy"]', visibleSlides()[0] || track).forEach(function (img) { img.loading = 'eager'; });
      goTo(0, false);
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(updateCount); }, { passive: true });
      $('[data-asc-gal-prev]', gal).addEventListener('click', function () { goTo(currentIndex() - 1); });
      $('[data-asc-gal-next]', gal).addEventListener('click', function () { goTo(currentIndex() + 1); });
      thumbs.forEach(function (t) {
        t.querySelector('button').addEventListener('click', function () {
          var visThumbs = thumbs.filter(function (x) { return !x.hidden; });
          goTo(visThumbs.indexOf(t));
        });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
      });
      window.addEventListener('resize', function () { goTo(currentIndex(), false); });
      updateCount();
    }

    /* ----- pick ----- */
    function pick(id, opts) {
      opts = opts || {};
      id = String(id || '');
      if (!allowed(id)) return false;
      var m = macs[id];
      picked = id;
      root.classList.add('is-picked');
      root.setAttribute('data-picked', id);
      idInput.value = id;
      $$('.asc-mac', root).forEach(function (el) {
        var on = el.getAttribute('data-asc-mac') === id;
        el.classList.toggle('is-on', on);
        var r = el.querySelector('input[type="radio"]');
        if (r) r.checked = on;
      });
      $$('[data-asc-chip]').forEach(function (b) {
        var on = b.getAttribute('data-asc-chip') === id;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var card = $('[data-asc-card]', root);
      if (card) {
        card.hidden = false;
        $('[data-asc-card-img]', card).innerHTML = '<img src="' + m.img + '" width="120" height="20" alt="">';
        $('[data-asc-card-name]', card).innerHTML = m.name.split(' ').map(function (w) { var s = document.createElement('span'); s.className = 'asc-nw'; s.textContent = w; return s.outerHTML; }).join(' ');
        $('[data-asc-card-code]', card).textContent = m.code;
        $('[data-asc-card-years]', card).innerHTML = '<span class="asc-nw"></span> · <span class="asc-nw"></span>';
        var ys = $$('[data-asc-card-years] .asc-nw', card); ys[0].textContent = m.years; ys[1].textContent = m.chips;
      }
      $$('[data-asc-price]').forEach(function (el) { el.textContent = m.priceText; });
      var sub = stickyDesk && $('[data-asc-sticky-sub]', stickyDesk);
      if (sub) sub.textContent = m.name + ' · ' + m.code;
      var pl = stickyMob && $('[data-asc-sticky-pick-label]', stickyMob);
      if (pl) { pl.textContent = '✓ ' + m.chip; pl.parentNode.hidden = false; }
      var pc = stickyMob && $('[data-asc-sticky-code]', stickyMob);
      if (pc && m.code) { pc.textContent = m.code; pc.hidden = false; }
      var ml = stickyMob && $('[data-asc-sticky-mob-label]', stickyMob);
      if (ml) ml.textContent = 'Add to cart';
      if (nudge) nudge.hidden = true;
      errEl.hidden = true;
      if (!m.available) { atc.disabled = true; $('[data-asc-atc-label]', atc).textContent = 'Sold out'; }
      else { atc.disabled = false; $('[data-asc-atc-label]', atc).textContent = 'Add to cart'; }
      // one gallery for every Mac (today's images minus the slides with old facts); no per-pick filtering
      if (opts.user) {
        memSet(id);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('asc:pdp:picked', { detail: { id: Number(id), sku: m.sku, source: opts.source || 'pdp' } }));
      return true;
    }

    $$('.asc-mac__radio', root).forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) pick(r.value, { user: true }); });
    });
    $$('[data-asc-chip]').forEach(function (b) {
      b.addEventListener('click', function () { pick(b.getAttribute('data-asc-chip'), { user: true }); });
    });

    /* ----- quantity ----- */
    var QMAX = 20;
    // Quantity boxes: text inputs with a numeric keypad (selection works in iOS Safari, unlike type=number).
    // Focus (tap, click or Tab) selects the whole value so typing replaces it: tap "1", type 2 → 2, never 21.
    // A tap's mouseup would undo the selection in Safari, so the first one after focus is swallowed (as on the teams page).
    (function () {
      var justFocused = null;
      function selectAll(input) { try { input.setSelectionRange(0, input.value.length); } catch (e) { try { input.select(); } catch (e2) {} } }
      root.addEventListener('focusin', function (e) {
        var input = e.target.closest && e.target.closest('.asc-qty__input'); if (!input) return;
        justFocused = input; setTimeout(function () { selectAll(input); }, 0);
      });
      root.addEventListener('mouseup', function (e) { if (justFocused && e.target === justFocused) { e.preventDefault(); justFocused = null; } });
      root.addEventListener('touchend', function (e) {
        var input = justFocused; if (!input || e.target !== input) return;
        setTimeout(function () { if (document.activeElement === input) selectAll(input); justFocused = null; }, 0);
      });
      root.addEventListener('focusout', function (e) { if (e.target === justFocused) justFocused = null; });
      root.addEventListener('beforeinput', function (e) {
        if (!e.target.classList || !e.target.classList.contains('asc-qty__input')) return;
        if (e.data && /[^0-9]/.test(e.data)) e.preventDefault(); // digits only
      });
      root.addEventListener('input', function (e) {
        if (!e.target.classList || !e.target.classList.contains('asc-qty__input')) return;
        var d = e.target.value.replace(/[^0-9]/g, ''); if (d !== e.target.value) e.target.value = d; // pasted text
      });
    })();
    var maxNote = $('[data-asc-qty-max]', root);
    function clampQty(v) { v = parseInt(v, 10); if (!isFinite(v) || v < 1) v = 1; if (v > QMAX) v = QMAX; return v; }
    function syncQtyButtons(wrap, v, triedMore) {
      var minus = wrap.querySelector('[data-asc-qty-step="-1"]');
      var plus = wrap.querySelector('[data-asc-qty-step="1"]');
      if (minus) minus.disabled = v <= 1;
      if (plus) plus.disabled = v >= QMAX;
      if (maxNote) maxNote.hidden = !(v >= QMAX && triedMore);
    }
    $$('[data-asc-qty]', root).forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-asc-qty-step]');
        if (!b) return;
        var v = clampQty(Number(input.value) + Number(b.getAttribute('data-asc-qty-step')));
        input.value = v; syncQtyButtons(wrap, v, v >= QMAX);
      });
      input.addEventListener('change', function () { var raw = parseInt(input.value, 10); var v = clampQty(input.value); input.value = v; syncQtyButtons(wrap, v, raw >= QMAX); });
      syncQtyButtons(wrap, clampQty(input.value));
    });

    /* ----- add to cart ----- */
    function showNudge() {
      if (nudge) {
        nudge.hidden = false;
        var list = $('.asc-pick__list', root);
        var top = list.getBoundingClientRect().top + window.scrollY - 140;
        if (list.getBoundingClientRect().top < 80 || list.getBoundingClientRect().bottom > window.innerHeight) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        var first = $('.asc-mac__radio', root);
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      }
    }
    // "Adding…" on whichever add button was used; "Added" for a moment after success
    function labelEl(btn) { return btn.querySelector('[data-asc-atc-label], [data-asc-sticky-mob-label]') || btn; }
    function busy(btn, on, done) {
      if (!btn) return;
      var el = labelEl(btn);
      if (on) {
        if (!btn._ascLabel) btn._ascLabel = el.textContent;
        el.textContent = 'Adding…';
        btn.disabled = true;
      } else {
        var restore = function () { if (btn._ascLabel) el.textContent = btn._ascLabel; btn._ascLabel = null; btn.disabled = false; };
        if (done) { el.textContent = 'Added ✓'; setTimeout(restore, 1600); } else restore();
      }
      btn.classList.toggle('is-busy', on);
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    function submit(btn) {
      if (!picked) { showNudge(); return Promise.resolve(false); }
      var items = [{ id: Number(picked), quantity: clampQty(qtyInput.value) }];
      errEl.hidden = true;
      busy(btn, true);
      memSet(picked);
      return addToCart(items).then(function () {
        busy(btn, false, true);
        document.dispatchEvent(new CustomEvent('asc:pdp:added', { detail: { items: items } }));
        return true;
      }).catch(function (err) {
        busy(btn, false);
        errEl.textContent = (err && err.message) || 'Could not add to cart. Please try again.';
        errEl.hidden = false;
        return false;
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(atc); });
    var dynCover = $('[data-asc-dyn-cover]', root);
    if (dynCover) dynCover.addEventListener('click', showNudge);

    /* ----- sticky bars: only once the main button has scrolled above the viewport ----- */
    var buyRow = $('[data-asc-buy-row]', root);
    var stickyOn = false;
    function setSticky(on) {
      if (on === stickyOn) return;
      stickyOn = on;
      [stickyDesk, stickyMob].forEach(function (s) {
        if (!s) return;
        s.classList.toggle('is-shown', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      document.documentElement.classList.toggle('asc-sticky-on', on);
    }
    // fr1 #15d: Loox's script injects star widgets next to prices it finds; never inside our sticky bars
    if ('MutationObserver' in window) {
      [stickyDesk, stickyMob].forEach(function (bar) {
        if (!bar) return;
        var clean = function () { $$('[class*="loox"], [id*="loox"]', bar).forEach(function (n) { n.remove(); }); };
        new MutationObserver(clean).observe(bar, { childList: true, subtree: true });
        clean();
      });
    }
    // fr1 #15c: the state is computed from the buy row's position, not only from IntersectionObserver callbacks:
    // a reload mid-page or a jump moves the row from below to above the viewport without ever crossing it, and
    // Safari then fires no callback, so the bar never appeared. Recomputed on load, scroll, resize and pageshow.
    function syncSticky() {
      if (!buyRow) return;
      var r = buyRow.getBoundingClientRect();
      setSticky(r.height > 0 && r.bottom < 0);
    }
    var stickyRaf = 0;
    function queueSticky() { cancelAnimationFrame(stickyRaf); stickyRaf = requestAnimationFrame(syncSticky); }
    if (buyRow) {
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
      window.addEventListener('pageshow', queueSticky);
      window.addEventListener('load', queueSticky);
      if ('IntersectionObserver' in window) new IntersectionObserver(queueSticky, { threshold: 0 }).observe(buyRow);
      syncSticky(); setTimeout(syncSticky, 400); setTimeout(syncSticky, 1500);
    }
    var sAtc = stickyDesk && $('[data-asc-sticky-atc]', stickyDesk);
    if (sAtc) sAtc.addEventListener('click', function () {
      if (!picked) {
        var sub = $('[data-asc-sticky-sub]', stickyDesk);
        sub.textContent = 'Pick your MacBook first:';
        var c = $('[data-asc-chip]', stickyDesk); if (c) c.focus();
        return;
      }
      submit(sAtc);
    });
    var mAtc = stickyMob && $('[data-asc-sticky-atc-mob]', stickyMob);
    if (mAtc) mAtc.addEventListener('click', function () {
      if (!picked) { openSheet('pick', mAtc); return; }
      submit(mAtc);
    });

    /* ----- sheet: four Mac cards (phone sticky bar D18) ----- */
    var sheet = dlg.sheet;
    var sheetCta = sheet && $('[data-asc-sheet-cta]', sheet);
    function setSheetChoice(id) {
      sheetChoice = id;
      $$('[data-asc-mcard]', sheet).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-asc-mcard') === id ? 'true' : 'false'); });
      sheetCta.disabled = !id;
    }
    function openSheet(mode, opener) {
      if (!sheet) return;
      sheetMode = mode;
      $('[data-asc-sheet-title]', sheet).textContent = 'Which MacBook do you have?';
      sheetCta.textContent = 'Add to cart';
      setSheetChoice(picked);
      openDialog(sheet, opener);
    }
    if (sheet) {
      $$('[data-asc-mcard]', sheet).forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.getAttribute('data-asc-mcard');
          setSheetChoice(id);
          if (sheetMode === 'pick') pick(id, { user: true });
        });
      });
      sheetCta.addEventListener('click', function () {
        if (!sheetChoice) return;
        closeDialog(sheet);
        submit(mAtc && stickyOn ? mAtc : atc);
      });
    }

    /* ----- dialog openers ----- */
    /* fr3 #3: from inside an open dialog (specs) "Displays by chip" is a second VIEW of that same dialog, not a
       modal on top: the displays box moves into it, its own box hides, a Back button returns. Close/Escape close the dialog. */
    var BACK_TO = { specs: 'Back to specs' };
    function enterDispView(host, box, opener) {
      var own = $('.asc-dlg__box', host);
      own.hidden = true;
      host.appendChild(box);
      host.classList.add('asc-dlg--disp', 'is-view2');
      $('[data-asc-disp-back-label]', box).textContent = BACK_TO[host.getAttribute('data-asc-dlg')] || 'Back';
      $('[data-asc-disp-backrow]', box).hidden = false;
      box._host = { host: host, own: own, opener: opener };
      host.scrollTop = 0; box.scrollTop = 0;
      if (!host._ascViewWired) { host._ascViewWired = true; host.addEventListener('close', function () { leaveDispView(host, false); }); }
      var t = $('[data-asc-autofocus]', box);
      if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
    }
    function leaveDispView(host, focusBack) {
      var d = dlg.displays, box = d && d._box;
      if (!box || !box._host || box._host.host !== host) return;
      var st = box._host; box._host = null;
      d.appendChild(box);
      st.own.hidden = false;
      host.classList.remove('asc-dlg--disp', 'is-view2', 'is-mine');
      $('[data-asc-disp-backrow]', box).hidden = true;
      host.scrollTop = 0;
      if (focusBack && st.opener && document.contains(st.opener)) { try { st.opener.focus({ preventScroll: true }); } catch (e) { st.opener.focus(); } }
    }
    function openDisplays(opener) {
      var d = dlg.displays; if (!d) return;
      var box = d._box || (d._box = $('.asc-dlg__box', d));
      var host = opener && opener.closest ? opener.closest('dialog.asc-dlg[open]') : null;
      if (host === d) host = null;
      var mineTab = $('[data-asc-disp-tab="mine"]', box), allTab = $('[data-asc-disp-tab="all"]', box);
      function show(which) {
        mineTab.setAttribute('aria-selected', which === 'mine' ? 'true' : 'false');
        allTab.setAttribute('aria-selected', which === 'all' ? 'true' : 'false');
        $$('[data-asc-disp]', box).forEach(function (t) { t.hidden = which === 'mine' && t.getAttribute('data-asc-disp') !== picked; });
        $('[data-asc-disp-title]', box).textContent = which === 'mine' && picked ? 'Displays with your ' + macs[picked].name : 'Displays by chip';
        (box.closest('dialog') || d).classList.toggle('is-mine', which === 'mine');
      }
      if (!box._backWired) {
        box._backWired = true;
        $('[data-asc-disp-back]', box).addEventListener('click', function () { if (box._host) leaveDispView(box._host.host, true); });
      }
      if (host) enterDispView(host, box, opener);
      if (!d._wired) {
        d._wired = true;
        mineTab.addEventListener('click', function () { show('mine'); });
        allTab.addEventListener('click', function () { show('all'); });
      }
      if (picked) { mineTab.hidden = false; mineTab.textContent = macs[picked].chip; show('mine'); }
      else { mineTab.hidden = true; show('all'); }
      if (!host) openDialog(d, opener);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-asc-open], a[href="#asc-displays"], a[href="#asc-find-model"]');
      if (b) {
        e.preventDefault();
        var what = b.getAttribute('data-asc-open') || { '#asc-displays': 'displays', '#asc-find-model': 'helper' }[b.getAttribute('href')];
        if (what === 'helper') openDialog(dlg.helper, b);
        else if (what === 'displays') openDisplays(b);
        else if (what === 'specs') openDialog(dlg.specs, b);
        else if (what === 'sheet') openSheet('pick', b);
        return;
      }
      var c = e.target.closest('[data-asc-close]');
      if (c) { var d = c.closest('dialog'); if (d) closeDialog(d); }
    });
    document.addEventListener('keydown', trapFocus, true);

    /* model help: "This is mine" picks the Mac and closes (leftovers C) */
    $$('[data-asc-mine]', dlg.helper || document.createElement('div')).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-asc-mine');
        pick(id, { user: true });
        $$('[data-asc-hcard]', dlg.helper).forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-asc-hcard') === id); });
        if (sheet && sheet.open) setSheetChoice(id);
        closeDialog(dlg.helper);
        if (!(sheet && sheet.open)) {
          openers.set(dlg.helper, $('.asc-mac[data-asc-mac="' + id + '"] .asc-mac__radio', root));
        }
      });
    });

    /* fr3 #14 (w29): no Details toggle and no "Your desk setup" dialog any more; the picked card shows only its own row */

    /* ----- delivery line ----- */
    var edd = $('[data-asc-edd]', root);
    function renderEdd() {
      var t = null;
      try { t = eddText(); } catch (e) { t = null; }
      if (t) { $('[data-asc-edd-text]', edd).innerHTML = t; edd.hidden = false; } else edd.hidden = true;
    }
    if (edd) {
      renderEdd();
      var tries = 0;
      var poll = setInterval(function () { tries++; if (window.deliveryED || tries > 20) { renderEdd(); if (window.deliveryED || tries > 20) clearInterval(poll); } }, 500);
      setInterval(renderEdd, 60000);
    }

    /* ----- initial state: server pick (?variant=), else URL, else the remembered Mac ----- */
    var params; try { params = new URL(window.location.href).searchParams; } catch (e) { params = null; }
    var urlVariant = params && params.get('variant');
    if (picked && allowed(picked)) {
      pick(picked, { gallery: false, source: 'url' });
    } else if (urlVariant) {
      if (allowed(urlVariant)) pick(urlVariant, { source: 'url' });
      else {
        // an old or unknown variant ID: no selection, the remembered Mac is not applied either,
        // and the ID leaves the address bar (utm/fbclid stay) so a re-shared link doesn't carry it
        try { var cu = new URL(window.location.href); cu.searchParams.delete('variant'); history.replaceState(history.state, '', cu.pathname + cu.search + cu.hash); } catch (e) {}
        // a reload of the cleaned URL (e.g. a market redirect) must not fall back to the remembered Mac either
        try { sessionStorage.setItem('asc.pdp.nomem', String(Date.now())); } catch (e) {}
      }
    } else {
      var skip = false;
      try { var t = Number(sessionStorage.getItem('asc.pdp.nomem')); skip = t && Date.now() - t < 60000; sessionStorage.removeItem('asc.pdp.nomem'); } catch (e) {}
      var mem = memGet();
      if (!skip && mem && allowed(mem)) pick(mem, { source: 'memory' });
    }

    /* model help from a link: /products/…#find-your-model (nav menu, gift card page) */
    function helperFromHash() {
      if (location.hash === '#find-your-model' && dlg.helper && !dlg.helper.open) {
        openDialog(dlg.helper, $('.asc-pick__help', root));
        dlg.helper.addEventListener('close', function clr() {
          dlg.helper.removeEventListener('close', clr);
          if (location.hash === '#find-your-model') { try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {} }
        });
      }
    }
    helperFromHash();
    window.addEventListener('hashchange', helperFromHash);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="#find-your-model"]');
      if (!a) return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.pathname === location.pathname) { e.preventDefault(); openDialog(dlg.helper, a); }
    });

    /* public hook for other surfaces on this page */
    window.ascPdp = window.ascPdp || {};
    window.ascPdp.pick = function (id) { return pick(id, { user: true, source: 'api' }); };
    window.ascPdp.picked = function () { return picked ? Number(picked) : null; };
    window.ascPdp.openPicker = function () { openSheet('pick'); };
    window.ascPdp.openModelHelp = function () { openDialog(dlg.helper); };
  }

  /* ---------- in-page tabs: active state, and sitting under the header when it slides back in ---------- */
  function initTabs() {
    var tabs = $('[data-asc-pdp-tabs]') || $('.id-tab-list');
    if (!tabs) return;
    var links = $$('a[href^="#"]', tabs);
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var header = document.querySelector('sticky-header, .section-header');
    var raf = 0, lockUntil = 0, follow = null;
    /* fr3 #5: when the header hides on scroll-down it moves up by --header-height (header minus the tabs), but the tabs
       start 3 px lower in the header (its top border), so they were clipped. asc-pdp.css hides it by this offset instead. */
    function tabsOff() {
      var s = document.querySelector('.section-header'), w = s && s.querySelector('.id-tab-listwrap');
      if (!w || !w.offsetParent) return;
      var off = Math.round(w.getBoundingClientRect().top - s.getBoundingClientRect().top);
      if (off > 0) document.documentElement.style.setProperty('--asc-tabs-off', off + 'px');
    }
    tabsOff(); window.addEventListener('resize', tabsOff); window.addEventListener('load', tabsOff);
    if ('ResizeObserver' in window && header) new ResizeObserver(tabsOff).observe(header);
    function coverBottom() {
      var top = 0;
      if (header) {
        var r = header.getBoundingClientRect(), cs = getComputedStyle(header);
        if (r.bottom > 0 && (cs.position === 'sticky' || cs.position === 'fixed')) top = r.bottom;
      }
      var t = tabs.getBoundingClientRect();
      if (t.height && t.bottom > 0) top = Math.max(top, t.bottom);
      return top;
    }
    function setActive(i) {
      links.forEach(function (a, k) {
        a.classList.toggle('is-active', k === i);
        if (k === i) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
        if (a.parentElement && a.parentElement.tagName === 'LI') a.parentElement.classList.toggle('active', k === i);
      });
    }
    // scroll spy: the active tile is the last section whose anchor has reached the band where tapped headings land
    function spy() {
      if (Date.now() < lockUntil) return;
      var line = coverBottom() + 150, active = 0;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) active = i; });
      setActive(active);
    }
    function onScroll() { cancelAnimationFrame(raf); raf = requestAnimationFrame(spy); }
    // fr1 #15b: we handle the tap. The tile is active at once; the jump is re-applied while late content (Loox, lazy
    // images, videos) shifts the page during the next 3 s, unless the visitor scrolls themselves.
    function stopFollow() { if (follow) { follow.ro && follow.ro.disconnect(); clearTimeout(follow.t); follow = null; } }
    // the theme sets html { scroll-behavior: smooth }; a jump must land at once so late layout shifts can be measured
    function instantScroll(top) {
      var h = document.documentElement, prev = h.style.scrollBehavior;
      h.style.scrollBehavior = 'auto'; window.scrollTo(0, top); h.style.scrollBehavior = prev;
    }
    // the heading the visitor should see: the first h1/h2 at or after the anchor
    function headingFor(t) {
      if (t.id === 'product-section') return document.querySelector('.asc-pdp__title') || t;
      var own = t.matches('h1, h2') ? t : t.querySelector('h1, h2');
      if (own) return own;
      var hs = document.querySelectorAll('main h1, main h2');
      for (var k = 0; k < hs.length; k++) { if (t.compareDocumentPosition(hs[k]) & Node.DOCUMENT_POSITION_FOLLOWING && hs[k].offsetParent) return hs[k]; }
      return t;
    }
    // the sticky header hides on the way down and shows on the way up, so the gap depends on the direction
    function jump(t) {
      var h = headingFor(t);
      var y = h.getBoundingClientRect().top + window.scrollY;
      var down = y - 16 > window.scrollY;
      /* fr3 #5: the header hides on the way down but the tabs stay pinned; on the way up both show */
      var headH = header ? header.getBoundingClientRect().height : 0, tabsH = tabs.getBoundingClientRect().height || 0;
      var to = t.id === 'product-section' ? 0 : Math.max(0, y - (down ? tabsH + 16 : Math.max(headH, tabsH) + 16));
      instantScroll(to);
    }
    // fr1/fr2 #40: the tapped tile lights on the first touch, the spy is paused from then on, and the jump runs one frame
    // after the click so the highlight is painted before the (heavy) scroll of a long page.
    function tileOf(e) { var a = e.target.closest && e.target.closest('a[href^="#"]'); var i = a ? links.indexOf(a) : -1; return i < 0 || !targets[i] ? null : { a: a, i: i, t: targets[i] }; }
    tabs.addEventListener('pointerdown', function (e) {
      var x = tileOf(e); if (!x) return;
      setActive(x.i); lockUntil = Date.now() + 3500;
    }, true);
    tabs.addEventListener('click', function (e) {
      var x = tileOf(e); if (!x) return;
      var a = x.a, i = x.i, t = x.t;
      e.preventDefault(); e.stopPropagation();
      stopFollow();
      setActive(i);
      lockUntil = Date.now() + 3500;
      requestAnimationFrame(function () {
        setTimeout(function () {
          jump(t);
          try { history.replaceState(history.state, '', a.getAttribute('href')); } catch (err) {}
          var hEl = headingFor(t), want = hEl.getBoundingClientRect().top;
          lockUntil = Date.now() + 3200;
          follow = { t: setTimeout(function () { stopFollow(); lockUntil = Date.now() + 300; }, 3000) };
          if ('ResizeObserver' in window) {
            follow.ro = new ResizeObserver(function () {
              if (!follow) return;
              if (Math.abs(hEl.getBoundingClientRect().top - want) > 4) { instantScroll(window.scrollY + hEl.getBoundingClientRect().top - want); want = hEl.getBoundingClientRect().top; }
            });
            follow.ro.observe(document.body);
          }
        }, 0);
      });
    }, true);
    ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (follow) { stopFollow(); lockUntil = 0; } }, { passive: true });
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    window.ascPdpTabsReady = true;
    onScroll();
  }

  /* ---------- link helper for other pages (menu, home): build a PDP link with a Mac preselected ---------- */
  window.ascPdp = window.ascPdp || {};
  window.ascPdp.url = function (variantId, base) {
    var u = new URL(base || '/products/ascrono-macbook-docking-station', window.location.origin);
    if (variantId) u.searchParams.set('variant', String(variantId));
    return u.pathname + u.search;
  };

  /* ---------- fr1 #39: scroll restoration after a reload lands where you were, also when Loox loads late ---------- */
  function initRestore() {
    if (!('scrollRestoration' in history) || !window.sessionStorage) return;
    var KEY = 'asc.pdp.scroll';
    var ids = ['product-section', 'asc-proof', 'how', 'asc-creators', 'customer-asc', 'faq'];
    function anchors() { return ids.map(function (id) { return document.getElementById(id); }).filter(Boolean); }
    history.scrollRestoration = 'manual';
    window.addEventListener('pagehide', function () {
      var y = window.scrollY, best = null;
      anchors().forEach(function (a) { var top = a.getBoundingClientRect().top + y; if (top <= y + 1) best = { id: a.id, off: y - top }; });
      try { sessionStorage.setItem(KEY, JSON.stringify({ path: location.pathname, y: y, id: best && best.id, off: best ? best.off : y, t: Date.now() })); } catch (e) {}
    });
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    if (nav.type !== 'reload' && nav.type !== 'back_forward') return;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!saved || saved.path !== location.pathname || Date.now() - saved.t > 30 * 60 * 1000 || saved.y < 50) return;
    var stop = false, done = 0;
    function target() {
      var a = saved.id && document.getElementById(saved.id);
      return a ? a.getBoundingClientRect().top + window.scrollY + saved.off : saved.y;
    }
    function go() {
      if (stop) return;
      var to = Math.max(0, Math.round(target()));
      if (Math.abs(window.scrollY - to) > 2) {
        var h = document.documentElement, prev = h.style.scrollBehavior;
        h.style.scrollBehavior = 'auto'; window.scrollTo(0, to); h.style.scrollBehavior = prev;
      }
    }
    var halt = function () { stop = true; };
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, halt, { passive: true, once: true }); });
    go();
    var ro = 'ResizeObserver' in window ? new ResizeObserver(go) : null;
    if (ro) ro.observe(document.body);
    window.addEventListener('load', go);
    setTimeout(function () { stop = true; if (ro) ro.disconnect(); }, 8000);
  }

  function boot() {
    initRestore();
    $$('[data-asc-pdp]').forEach(initPdp);
    initTabs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
